module.exports = new __parcel__URL__("hunter.2db1e2af.png").toString();